/**
 * Default/fallback import data type templates.
 * Used when config is not available from the API (no Supabase row yet).
 * Matches the 7 types shown in the QuickBooks-style import screen.
 */

export const IMPORT_DATA_TYPE_TEMPLATES = [
    {
        key: 'bank_data',
        label: 'Bank Data',
        displayOrder: 1,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'AccountBalance', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your bank transactions',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/bank_data' },
    },
    {
        key: 'customers',
        label: 'Customers',
        displayOrder: 2,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'PeopleAlt', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your customer list',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/customers' },
    },
    {
        key: 'suppliers',
        label: 'Suppliers',
        displayOrder: 3,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'Storefront', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your supplier list',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/suppliers' },
    },
    {
        key: 'chart_of_accounts',
        label: 'Chart of Accounts',
        displayOrder: 4,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'AccountTree', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your chart of accounts',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/chart_of_accounts' },
    },
    {
        key: 'products_and_services',
        label: 'Products and Services',
        displayOrder: 5,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'Inventory2', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your products and services',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/products_and_services' },
    },
    {
        key: 'invoices',
        label: 'Invoices',
        displayOrder: 6,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'Receipt', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your invoices',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/invoices' },
    },
    {
        key: 'bills',
        label: 'Bills',
        displayOrder: 7,
        isVisible: true,
        isEnabled: true,
        iconConfig: { icon: 'RequestQuote', iconColor: '#ffffff', bubbleColor: '#4caf50' },
        description: 'Import your bills',
        acceptedFormats: ['.csv', '.xlsx'],
        actionConfig: { navigateTo: '/import/bills' },
    },
];
